import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

import { DynamicGrafana } from './components/DynamicGrafana';

export const grafanaPlugin = createFrontendPlugin({
  extensions: [DynamicGrafana],
  pluginId: 'grafana',
});
